module.exports = __webpack_public_path__ + "img/l.4ac434c7.jpg";